/**
 * @desc Export table layout configuration.
 * @example
 * import { layoutConfig } from 'config/table-configs/transfer-queue';
 */
export const layoutConfig = {
    styles: {
        borderlessSearch: false,
    },
    dimensions: {
        maxHeight: 260,
    },
    columnWidth: {
        callId: 70,
        callDateAndTime: 90,
        duration: 80,
        callCallerType: 100,
        caller: 130,
        members: 130,
        representative: 130,
        resolution: 90,
        categoryAndReason: 140,
        callRecording: 70,
        
        // special columns
        _groupActions: 90, // group actions column
    },
    filterFlyoutWidths: {
        callCallerType: 200,
        resolution: 180,
        categoryAndReason: 300,
    },
    valueColors: {
        resolution: {
            resolved: '#59ad00',
            unresolved: '#e7aa00',
        },
    },
    actionIcons: {
        takeTransfer: 'transferCall',
        remove: 'cross'
    },
};
